import { TextField } from "@mui/material";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: any;
  className?: string;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  mode?: string;
};

function ProductSearchInput({
  disabled,
  className,
  label = "Produit",
  placeholder = "Par nom ou référence",
  value,
  onChange,
  mode = "both",
  ...props
}: Props) {
  const placeholderText = placeholder;
  let labelText = label;
  if (mode === "reference") {
    labelText = "Référence";
  } else if (mode === "designation") {
    labelText = "Désignation";
  }
  return (
    <TextField
      placeholder={placeholderText}
      className={className}
      disabled={disabled}
      value={value}
      label={labelText}
      variant="outlined"
      type="text"
      onChange={onChange}
      sx={{ width: "100%" }}
      InputLabelProps={{ shrink: true }}
      {...props}
    />
  );
}

export default ProductSearchInput;

export const getProductFilterResult = (
  filtered: any,
  filterProduct: any,
  isRoot: boolean,
  mode?: string
) => {
  if (filterProduct && filterProduct !== "") {
    return filtered.filter((u: any) => {
      if (isRoot) {
        if (mode === "reference") {
          return u.reference
            .toLowerCase()
            .includes(filterProduct?.toLowerCase());
        }
        if (mode === "designation") {
          return u.designation
            .toLowerCase()
            .includes(filterProduct?.toLowerCase());
        }
        return (
          u.reference.toLowerCase().includes(filterProduct?.toLowerCase()) ||
          u.designation.toLowerCase().includes(filterProduct?.toLowerCase())
        );
      }
      if (mode === "reference") {
        return u.product.reference
          .toLowerCase()
          .includes(filterProduct?.toLowerCase());
      }
      if (mode === "designation") {
        return u.product.designation
          .toLowerCase()
          .includes(filterProduct?.toLowerCase());
      }
      return (
        u.product.reference
          .toLowerCase()
          .includes(filterProduct?.toLowerCase()) ||
        u.product.designation
          .toLowerCase()
          .includes(filterProduct?.toLowerCase())
      );
    });
  }
  return filtered;
};

export const getProductFieldMatch = (item: any, filter: any) => {
  if (filter !== "") {
    return Boolean(
      item?.toString().toLowerCase().includes(filter?.toLowerCase())
    );
  }
  return true;
};
